module.exports = __webpack_public_path__ + "media/images/bg_5-1da1828dc4c114649860b3d266104883.webp";